import PropTypes from 'prop-types';
import Tooltip from '@/components/Tooltip';
import TrainerInfoItem from './TrainerInfoItem';
import TrainerInfoCheck from './TrainerInfoCheck';

const defaultProps = {
  positiveValue: 'Sí',
  negativeValue: 'No',
  value: false,
};

const propTypes = {
  value: PropTypes.bool,
  label: PropTypes.string.isRequired,
  positiveValue: PropTypes.string,
  negativeValue: PropTypes.string,
};

export default function TrainerInfoCheckItem({
  value,
  label,
  positiveValue,
  negativeValue,
}) {
  return (
    <TrainerInfoItem label={label}>
      <Tooltip tooltip={value ? positiveValue : negativeValue}>
        <TrainerInfoCheck checked={value} />
      </Tooltip>
    </TrainerInfoItem>
  );
}

TrainerInfoCheckItem.defaultProps = defaultProps;
TrainerInfoCheckItem.propTypes = propTypes;
